import styled from "styled-components";

interface MainContentStyleProps {
  $commentFloat?: boolean;
}

export const MainContent = styled.div<MainContentStyleProps>`
  gap: 40px;
  display: flex;
  padding: ${(props) =>
    props.$commentFloat === true ? "16px 16px 102px" : "16px"};
  min-height: calc(100vh - 126px);
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const ContentItemBox = styled.div`
  gap: 16px;
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
